module.exports = "<div>\n    <input type=\"text\" [(ngModel)] = 'returnWono'>\n     <button class= 'btn btn-primary' (click) = 'workOrderReturn(\"Cancel\",{})'>Show</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/woReturn.html
// module id = ../../../../../src/app/components/Purchase/workorder/woReturn.html
// module chunks = main